/**
 *  Default locale option
 *
 * @constant
 */
export const DEFAULT_LOCALE = {
  id: 'default-locale',
  name: 'Default',
};
